import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export function PageLoader() {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(false), 200);
    return () => window.clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-38" data-mp="1cu4jz3rf6wxa">
      {visible && <motion.div aria-hidden="true" className="fixed inset-0 z-[60] bg-black" exit={{
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-39" data-mp="1ct348lzglm98" />}
    </AnimatePresence>;
}